import { configureStore } from '@swibeco/store';

export const store = configureStore();
